import { mergeStyles } from '@fluentui/react';

const dialogStyle = mergeStyles({
padding:"43px",
    overflow:"hidden",
    borderRadius:"2px"
  });
  const DialogFooterStyle = mergeStyles({
    bottom:"0px",
    margin:"0px"
      });

const dialogTextStyle = mergeStyles({
  color: '#333333'
})
  
  export {
    dialogStyle,DialogFooterStyle, dialogTextStyle
  };  